module.exports = __webpack_public_path__ + "img/期刊搜索.bc5d540e.png";